import axios from 'axios'
export default {
    namespaced: true,

    state: {
        organisationSettingsMap: [],
        myOrganisation: {},
        myOrganisationSettings: {}
    }, 

    getters: {
        GetOrganisationSettingsMap(state) {
            return state.organisationSettingsMap
        },

        GetMyOrganisation(state) {
            return state.myOrganisation
        },

        GetMyOrganisationSettings(state) {
            return state.myOrganisationSettings
        },

        GetMyOrganisationId(state) {
            return state.myOrganisation.id
        },

        GetMyOrganisationCountryCode(state) {
            return state.myOrganisation.address.countryCode
        },

        GetPatientIdentifierLabel(state) {
            return state.myOrganisation.patientIdentifierLabel
        },

        GetPatientIdentifierRegex(state) {
            return state.myOrganisation.patientIdentifierValidationRegex
        },

        GetPatientIdentifierErrorMessage(state) {
            return state.myOrganisation.patientIdentifierErrorMessage
        },

        GetIsTrial(state) {
            return state.myOrganisation.isTrial
        },

        GetDefaultPhoneCountryCode(state) {
            return state.myOrganisation.defaultPhoneCountryCode
        },

        GetDomainId(state) {
            return state.myOrganisation.domainId
        }
    },

    mutations: {
        PUSH_MY_ORGANISATION(state, data) {
            state.myOrganisation = data
        },

        PUSH_MY_ORGANISATION_SETTINGS(state, data) {
            state.myOrganisationSettings = data
        },

        PUSH_ORGANISATION_SETTINGS_MAP(state, data) {
            state.organisationSettingsMap = data
        }
    },

    actions: {
        async GetOrganisationSettingsMap({commit}) {
            try {
                let response = await axios.get(`${process.env.VUE_APP_AXIOS_ORGANISATION_BASE_URL}/api/v1/organisationsettings/testreasonskeyvalue`)

                commit('PUSH_ORGANISATION_SETTINGS_MAP', response.data)

                return response
            }
            catch(err) {
                throw new Error(err)
            }
        },

        async GetMyOrganisation({commit}) {
            try {
                let response = await axios.get(`${process.env.VUE_APP_AXIOS_ORGANISATION_BASE_URL}/api/v1/organisations/me`)

                commit('PUSH_MY_ORGANISATION', response.data)

                return response
            }
            catch(err) {
                throw new Error(err)
            }
        },

        async GetMyOrganisationSettings({commit}) {
            try {
                let response = await axios.get(`${process.env.VUE_APP_AXIOS_ORGANISATION_BASE_URL}/api/v1/organisationsettings/me`)

                commit('PUSH_MY_ORGANISATION_SETTINGS', response.data)

                return response
            }
            catch(err) {
                throw new Error(err)
            }
        }
    }
}